import Head from "next/head";
import { MedspaOnlineStoreDataQuery } from "@/graphql/queries/onlineStore/medspaOnlineStoreData.graphql.types";
import MetaPixel from "../booking/metaPixel";

export default function PackagesPageHead({
  medspa,
}: {
  medspa: MedspaOnlineStoreDataQuery["medspa"][number];
}) {
  const title = `${medspa.name} Packages`;
  const description = `Unlock ultimate relaxation and rejuvenation at ${medspa.name}. Explore and purchase from a selection of exquisite packages, each promising a unique blend of luxurious services and products bundled together for unmatched value and experience.`;

  return (
    <>
      <Head>
        <title>{title}</title>
        <meta name="description" content={description} />

        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />

        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />

        {/* Prevent search engines from indexing this page */}
        <meta name="robots" content="noindex"></meta>
      </Head>

      {/* Meta Pixel Code - must be outside head */}
      {medspa.metaPixelId && <MetaPixel id={medspa.metaPixelId} />}
    </>
  );
}
